// Copyright (c) 2016 Deere & Company

export default Object.freeze({
    ADD_CLAIM_JDP_ADDITIONAL_REPAIR: 'ADD_CLAIM_JDP_ADDITIONAL_REPAIR',
    ADD_CLAIM_JDP_FILE: 'ADD_CLAIM_JDP_FILE',
    COPY_CLAIM_JDP: 'COPY_CLAIM_JDP',
    CREATE_CLAIM_JDP_LABOR: 'CREATE_CLAIM_JDP_LABOR',
    CREATE_CLAIM_JDP_OTHER_CREDIT: 'CREATE_CLAIM_JDP_OTHER_CREDIT',
    CREATE_CLAIM_JDP_PART: 'CREATE_CLAIM_JDP_PART',
    DELETE_CLAIM_JDP_FILE: 'DELETE_CLAIM_JDP_FILE',
    DELETE_CLAIM_JDP_LABOR: 'DELETE_CLAIM_JDP_LABOR',
    DELETE_CLAIM_JDP_OTHER_CREDIT: 'DELETE_CLAIM_JDP_OTHER_CREDIT',
    DELETE_CLAIM_JDP_PART: 'DELETE_CLAIM_JDP_PART',
    RESET_CKC_CUSTOMER_FAILURE: 'RESET_CKC_CUSTOMER_FAILURE',
    RESET_CLAIM_JDP: 'RESET_CLAIM_JDP',
    RESET_CLAIM_JDP_CONFIRMATION_MODAL: 'RESET_CLAIM_JDP_CONFIRMATION_MODAL',
    RESET_CLAIM_JDP_FORM_VALIDATION: 'RESET_CLAIM_JDP_FORM_VALIDATION',
    RESET_CLAIM_JDP_PRODUCT_DETAILS: 'RESET_CLAIM_JDP_PRODUCT_DETAILS',
    REVISE_CLAIM_JDP: 'REVISE_CLAIM_JDP',
    SET_CLAIM_JDP: 'SET_CLAIM_JDP',
    SET_CLAIM_JDP_CONFIRMATION_MODAL: 'SET_CLAIM_JDP_CONFIRMATION_MODAL',
    SET_CLAIM_JDP_CUSTOMER_DETAILS: 'SET_CLAIM_JDP_CUSTOMER_DETAILS',
    SET_CLAIM_JDP_PART_DETAILS: 'SET_CLAIM_JDP_PART_DETAILS',
    SET_CLAIM_JDP_PRODUCT_DETAILS: 'SET_CLAIM_JDP_PRODUCT_DETAILS',
    SET_CLAIM_JDP_REASONS: 'SET_CLAIM_JDP_REASONS',
    SET_CLAIM_JDP_RESOLUTIONS: 'SET_CLAIM_JDP_RESOLUTIONS',
    UPDATE_CKC_CUSTOMER_FAILURE: 'UPDATE_CKC_CUSTOMER_FAILURE',
    UPDATE_CLAIM_JDP_BASIS_FOR_SETTLEMENT: 'UPDATE_CLAIM_JDP_BASIS_FOR_SETTLEMENT',
    UPDATE_CLAIM_JDP_CLAIM_TYPES: 'UPDATE_CLAIM_JDP_CLAIM_TYPES',
    UPDATE_CLAIM_JDP_COMPLAINT_CAUSE: 'UPDATE_CLAIM_JDP_COMPLAINT_CAUSE',
    UPDATE_CLAIM_JDP_COMPLAINT_CORRECTION: 'UPDATE_CLAIM_JDP_COMPLAINT_CORRECTION',
    UPDATE_CLAIM_JDP_CREATE_CLAIM_MODAL_VISIBILITY: 'UPDATE_CLAIM_JDP_CREATE_CLAIM_MODAL_VISIBILITY',
    UPDATE_CLAIM_JDP_CUSTOMER_RESOLUTION: 'UPDATE_CLAIM_JDP_CUSTOMER_RESOLUTION',
    UPDATE_CLAIM_JDP_DELIVERY_DATE: 'UPDATE_CLAIM_JDP_DELIVERY_DATE',
    UPDATE_CLAIM_JDP_DOWN_TIME: 'UPDATE_CLAIM_JDP_DOWN_TIME',
    UPDATE_CLAIM_JDP_DTAC_CASE: 'UPDATE_CLAIM_JDP_DTAC_CASE',
    UPDATE_CLAIM_JDP_DTAC_SOLUTION: 'UPDATE_CLAIM_JDP_DTAC_SOLUTION',
    UPDATE_CLAIM_JDP_FAILED_AREA: 'UPDATE_CLAIM_JDP_FAILED_AREA',
    UPDATE_CLAIM_JDP_FAILED_MODE: 'UPDATE_CLAIM_JDP_FAILED_MODE',
    UPDATE_CLAIM_JDP_FAILED_MODE_COMMENTS: 'UPDATE_CLAIM_JDP_FAILED_MODE_COMMENTS',
    UPDATE_CLAIM_JDP_FAILURE_MODE_COLLECTION: 'UPDATE_CLAIM_JDP_FAILURE_MODE_COLLECTION',
    UPDATE_CLAIM_JDP_FAILURE_PART: 'UPDATE_CLAIM_JDP_FAILURE_PART',
    UPDATE_CLAIM_JDP_FILE_LIST: 'UPDATE_CLAIM_JDP_FILE_LIST',
    UPDATE_CLAIM_JDP_FORM_VALIDATION: 'UPDATE_CLAIM_JDP_FORM_VALIDATION',
    UPDATE_CLAIM_JDP_GOODS_INSTALLATION_VAT: 'UPDATE_CLAIM_JDP_GOODS_INSTALLATION_VAT',
    UPDATE_CLAIM_JDP_INSTALLED_BY: 'UPDATE_CLAIM_JDP_INSTALLED_BY',
    UPDATE_CLAIM_JDP_INSTALLED_BY_COLLECTION: 'UPDATE_CLAIM_JDP_INSTALLED_BY_COLLECTION',
    UPDATE_CLAIM_JDP_IS_ACTION_BUTTON_DISABLED: 'UPDATE_CLAIM_JDP_IS_ACTION_BUTTON_DISABLED',
    UPDATE_CLAIM_JDP_IS_COPIED: 'UPDATE_CLAIM_JDP_IS_COPIED',
    UPDATE_CLAIM_JDP_IS_EDITABLE: 'UPDATE_CLAIM_JDP_IS_EDITABLE',
    UPDATE_CLAIM_JDP_IS_VALID_CLAIM: 'UPDATE_CLAIM_JDP_IS_VALID_CLAIM',
    UPDATE_CLAIM_JDP_LABOR_FIELDS: 'UPDATE_CLAIM_JDP_LABOR_FIELDS',
    UPDATE_CLAIM_JDP_LABOR_LOCATION: 'UPDATE_CLAIM_JDP_LABOR_LOCATION',
    UPDATE_CLAIM_JDP_LABOR_TYPE: 'UPDATE_CLAIM_JDP_LABOR_TYPE',
    UPDATE_CLAIM_JDP_MODAL_MODE: 'UPDATE_CLAIM_JDP_MODAL_MODE',
    UPDATE_CLAIM_JDP_OPERATORS_COMMENTS: 'UPDATE_CLAIM_JDP_OPERATORS_COMMENTS',
    UPDATE_CLAIM_JDP_OPERATORS_COMPLAINT: 'UPDATE_CLAIM_JDP_OPERATORS_COMPLAINT',
    UPDATE_CLAIM_JDP_OTHER_CREDIT_AMOUNT: 'UPDATE_CLAIM_JDP_OTHER_CREDIT_AMOUNT',
    UPDATE_CLAIM_JDP_OTHER_CREDIT_COMMENTS: 'UPDATE_CLAIM_JDP_OTHER_CREDIT_COMMENTS',
    UPDATE_CLAIM_JDP_OTHER_CREDIT_DESCRIPTION: 'UPDATE_CLAIM_JDP_OTHER_CREDIT_DESCRIPTION',
    UPDATE_CLAIM_JDP_OTHER_CREDIT_DISTANCE: 'UPDATE_CLAIM_JDP_OTHER_CREDIT_DISTANCE',
    UPDATE_CLAIM_JDP_OWNERSHIP_STATUS: 'UPDATE_CLAIM_JDP_OWNERSHIP_STATUS',
    UPDATE_CLAIM_JDP_PART_FIELDS: 'UPDATE_CLAIM_JDP_PART_FIELDS',
    UPDATE_CLAIM_JDP_PART_SERIAL_NUMBER: 'UPDATE_CLAIM_JDP_PART_SERIAL_NUMBER',
    UPDATE_CLAIM_JDP_PART_UNIT: 'UPDATE_CLAIM_JDP_PART_UNIT',
    UPDATE_CLAIM_JDP_PIN: 'UPDATE_CLAIM_JDP_PIN',
    UPDATE_CLAIM_JDP_PROPERTY: 'UPDATE_CLAIM_JDP_PROPERTY',
    UPDATE_CLAIM_JDP_REASON_FOR_RETURN: 'UPDATE_CLAIM_JDP_REASON_FOR_RETURN',
    UPDATE_CLAIM_JDP_REPAIR_NUMBER: 'UPDATE_CLAIM_JDP_REPAIR_NUMBER',
    UPDATE_CLAIM_JDP_RESPONSIBLE_ACCOUNTS: 'UPDATE_CLAIM_JDP_RESPONSIBLE_ACCOUNTS',
    UPDATE_CLAIM_JDP_RETURN_DATE: 'UPDATE_CLAIM_JDP_RETURN_DATE',
    UPDATE_CLAIM_JDP_STICKY_HEADER_VISIBILITY: 'UPDATE_CLAIM_JDP_STICKY_HEADER_VISIBILITY',
    UPDATE_CLAIM_JDP_TEMPORARY_OBJECT_KEY: 'UPDATE_CLAIM_JDP_TEMPORARY_OBJECT_KEY',
    UPDATE_CLAIM_JDP_TYPE: 'UPDATE_CLAIM_JDP_TYPE',
    UPDATE_CLAIM_JDP_TYPES: 'UPDATE_CLAIM_JDP_TYPES',
    UPDATE_CLAIM_JDP_USE_AMOUNT: 'UPDATE_CLAIM_JDP_USE_AMOUNT',
    UPDATE_CLAIM_JDP_USE_AMOUNT_UNIT: 'UPDATE_CLAIM_JDP_USE_AMOUNT_UNIT',
    UPDATE_CLAIM_JDP_WORK_ORDER_ONE: 'UPDATE_CLAIM_JDP_WORK_ORDER_ONE',
    UPDATE_CLAIM_JDP_WORK_ORDER_TWO: 'UPDATE_CLAIM_JDP_WORK_ORDER_TWO'
});



// WEBPACK FOOTER //
// ./src/claim/marketing/jdp/action-list.js